import React from 'react';
import axiosInstance from '../../../../utils/axiosInstance';

const ProductDetail = ({ products, orderData }) => {
  return (
    <div className="text-sm mt-4">
      <p className="p-2 text-amber-500 font-bold">Product Details</p>
      {products.map((product) => (
        <div key={product._id} className="mb-4 bg-white p-4 rounded-lg shadow-md">
          <p className="mb-2 text-black">
            <strong>Name:</strong> {product.name}
          </p>
          <img
            src={`${axiosInstance.defaults.baseURL}/${product.image}`}
            className="w-16 h-16 md:h-10 object-cover mb-2 rounded-r-2xl"
            alt="Product"
          />
          <p className="mb-2 text-black">
            <strong>Price:</strong> {product.price}
          </p>
          <p className="mb-2 text-black">
            <strong>Description:</strong> {product.description}
          </p>
          <p className="mb-2 text-black">
            <strong>Quantity:</strong> {product.quantity}
          </p>
          {orderData.product
            .filter((orderProduct) => orderProduct.productId === product._id)
            .map((orderProduct) => (
              <div key={orderProduct._id} className="mb-4">
                <p className="mb-2 text-black">
                  <strong>Quantity:</strong> {orderProduct.quantity}
                </p>
                {/* Check if any cakeDetails property is true before displaying */}
                {Object.values(orderProduct.cakeDetails || {}).some((value) => value) && (
                  <div>
                    {orderProduct.cakeDetails.addEgg && (
                      <p className="mb-2 text-black">
                        <strong>Add Egg:</strong> {orderProduct.cakeDetails.addEgg.toString()}
                      </p>
                    )}
                    {orderProduct.cakeDetails.messageOnCake && (
                      <p className="mb-2 text-black">
                        <strong>Message on Cake:</strong> {orderProduct.cakeDetails.messageOnCake}
                      </p>
                    )}
                    {/* Add other cakeDetails properties as needed */}
                  </div>
                )}
                <hr className="my-2 border-gray-400" />
              </div>
            ))}
          <hr className="my-2 border-gray-400" />
        </div>
      ))}
    </div>
  );
};

export default ProductDetail;
